export default "__VITE_ASSET__COBd2twX__"